import { Controller } from "stimulus"

/**
 * Controls the payroll run import form, showing/hiding
 * fields based on the selected provider type.
 */
export default class extends Controller {
  static targets = ["csvSection"]

  connect() {
    this.toggleCsvSection()
  }

  providerChanged() {
    this.toggleCsvSection()
  }

  toggleCsvSection() {
    const select = this.element.querySelector("[data-provider-select]")
    if (!select) return

    const selectedOption = select.options[select.selectedIndex]
    const providerType = selectedOption ? selectedOption.dataset.providerType : null

    if (providerType === "csv_import") {
      this.csvSectionTarget.classList.remove("hidden")
    } else {
      this.csvSectionTarget.classList.add("hidden")
    }
  }
}
